"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("@vue/babel-helper-vue-jsx-merge-props"));

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/es.string.fixed.js");

require("core-js/modules/es.array.is-array.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.parse-int.js");

require("core-js/modules/web.timers.js");

var _checkbox = _interopRequireDefault(require("element-ui/lib/checkbox"));

var _radio = _interopRequireDefault(require("element-ui/lib/radio"));

var _tooltip = _interopRequireDefault(require("element-ui/lib/tooltip"));

var _dom = require("element-ui/lib/utils/dom");

var _debounce = _interopRequireDefault(require("throttle-debounce/debounce"));

var _vue = _interopRequireDefault(require("vue"));

var _layoutObserver = _interopRequireDefault(require("./layout-observer"));

var _menuPanel = _interopRequireDefault(require("./menu-panel.js"));

var _util = require("./util");

/** 扩展 右键菜单 */

/** */
var _default = {
  name: 'ElTableBody',
  mixins: [_layoutObserver["default"]],
  components: {
    ElCheckbox: _checkbox["default"],
    ElTooltip: _tooltip["default"],
    ElRadio: _radio["default"]
  },
  props: {
    store: {
      required: true
    },
    stripe: Boolean,
    context: {},
    rowClassName: [String, Function],
    rowStyle: [Object, Function],
    fixed: String,
    highlight: Boolean
  },
  render: function render(h) {
    var _this = this;

    var _vm = this;

    var columnsHidden = this.columns.map(function (column, index) {
      return _this.isColumnHidden(index);
    });
    return h("table", {
      "class": "el-table__body",
      "attrs": {
        "cellspacing": "0",
        "cellpadding": "0",
        "border": "0"
      }
    }, [h("colgroup", [this._l(this.columns, function (column) {
      return h("col", {
        "directives": [{
          name: "show",
          value: column.show
        }],
        "attrs": {
          "name": column.id
        }
      });
    })]), h("tbody", [this._l(this.data, function (row, $index) {
      return [h("tr", (0, _babelHelperVueJsxMergeProps["default"])([{
        "key": _this.table.rowKey ? _this.getKeyOfRow(row, $index) : $index,
        "on": {
          "dblclick": function dblclick($event) {
            return _this.handleDoubleClick($event, row);
          },
          "click": function click($event) {
            return _this.handleClick($event, row);
          },
          "contextmenu": function contextmenu($event) {
            return _this.handleContextMenu($event, row);
          },
          "mouseenter": function mouseenter(_) {
            return _this.handleMouseEnter($index);
          },
          "mouseleave": function mouseleave(_) {
            return _this.handleMouseLeave();
          }
        },
        "class": [_this.getRowClass(row, $index)]
      }, {
        style: _vm._px2rem(_this.rowStyle ? _this.getRowStyle(row, $index) : null, 24, [])
      }]), [_this._l(_this.columns, function (column, cellIndex) {
        var _this$getSpan = _this.getSpan(row, column, $index, cellIndex),
            rowspan = _this$getSpan.rowspan,
            colspan = _this$getSpan.colspan;

        if (!rowspan || !colspan) {
          return '';
        } else {
          return h("td", (0, _babelHelperVueJsxMergeProps["default"])([{
            "class": _this.getCellClass($index, cellIndex, row, column),
            "attrs": {
              "rowspan": rowspan,
              "colspan": colspan
            },
            "on": {
              "mouseenter": function mouseenter($event) {
                return _this.handleCellMouseEnter($event, row);
              },
              "mouseleave": _this.handleCellMouseLeave
            }
          }, {
            style: _vm._px2rem(_this.getCellStyle($index, cellIndex, row, column), 24, [])
          }]), [column.renderCell.call(_this._renderProxy, h, {
            row: row,
            column: column,
            $index: $index,
            store: _this.store,
            _self: _this.context || _this.table.$vnode.context
          }, columnsHidden[cellIndex])]);
        }
      })]), _this.store.isRowExpanded(row) ? h("tr", {
        "class": "el-table__expanded"
      }, [h("td", {
        "attrs": {
          "colspan": _this.columns.length
        },
        "class": "el-table__expanded-cell"
      }, [_this.table.renderExpanded ? _this.table.renderExpanded(h, {
        row: row,
        $index: $index,
        store: _this.store
      }) : ''])]) : ''];
    }).concat(h("el-tooltip", {
      "attrs": {
        "effect": this.table.tooltipEffect,
        "placement": "top"
      },
      "ref": "tooltip"
    }, [h("div", {
      "slot": "content"
    })]))])]);
  },
  watch: {
    'store.states.hoverRow': function storeStatesHoverRow(newVal, oldVal) {
      if (!this.store.states.isComplex) return;
      var el = this.$el;
      if (!el) return;
      var tr = el.querySelector('tbody').children;
      var rows = [].filter.call(tr, function (row) {
        return (0, _dom.hasClass)(row, 'el-table__row');
      });
      var oldRow = rows[oldVal];
      var newRow = rows[newVal];

      if (oldRow) {
        (0, _dom.removeClass)(oldRow, 'hover-row');
      }

      if (newRow) {
        (0, _dom.addClass)(newRow, 'hover-row');
      }
    },
    'store.states.currentRow': function storeStatesCurrentRow(newVal, oldVal) {
      if (!this.highlight) return;
      var el = this.$el;
      if (!el) return;
      var data = this.store.states.data;
      var tr = el.querySelector('tbody').children;
      var rows = [].filter.call(tr, function (row) {
        return (0, _dom.hasClass)(row, 'el-table__row');
      });
      var oldRow = rows[data.indexOf(oldVal)];
      var newRow = rows[data.indexOf(newVal)];

      if (oldRow) {
        (0, _dom.removeClass)(oldRow, 'current-row');
      } else {
        ;
        [].forEach.call(rows, function (row) {
          return (0, _dom.removeClass)(row, 'current-row');
        });
      }

      if (newRow) {
        (0, _dom.addClass)(newRow, 'current-row');
      }
    }
  },
  computed: {
    table: function table() {
      // 扩展  自定义滚动条
      // this.$parent.$vnode.tag.indexOf('ElTable') > 0;
      return this.$parent.$vnode.tag.indexOf('ElTable') > 0 ? this.$parent : this.$parent.$parent;
    },
    data: function data() {
      return this.store.states.data;
    },
    columnsCount: function columnsCount() {
      return this.store.states.columns.length;
    },
    leftFixedLeafCount: function leftFixedLeafCount() {
      return this.store.states.fixedLeafColumnsLength;
    },
    rightFixedLeafCount: function rightFixedLeafCount() {
      return this.store.states.rightFixedLeafColumnsLength;
    },
    leftFixedCount: function leftFixedCount() {
      return this.store.states.fixedColumns.length;
    },
    rightFixedCount: function rightFixedCount() {
      return this.store.states.rightFixedColumns.length;
    },
    columns: function columns() {
      return this.store.states.columns;
    }
  },
  data: function data() {
    return {
      tooltipContent: '',

      /** 扩展 右键菜单 */
      menuPanel: null
      /** */

    };
  },
  created: function created() {
    var _this2 = this;

    this.activateTooltip = (0, _debounce["default"])(50, function (tooltip) {
      return tooltip.handleShowPopper();
    });
    this.debounceMenuClick = (0, _debounce["default"])(50, function (event, row, table, menus, currentTarget) {
      return _this2.handleMenuClick(event, row, table, menus, currentTarget);
    });
  },
  methods: {
    getKeyOfRow: function getKeyOfRow(row, index) {
      var rowKey = this.table.rowKey;

      if (rowKey) {
        return (0, _util.getRowIdentity)(row, rowKey);
      }

      return index;
    },
    isColumnHidden: function isColumnHidden(index) {
      if (this.fixed === true || this.fixed === 'left') {
        return index >= this.leftFixedLeafCount;
      } else if (this.fixed === 'right') {
        return index < this.columnsCount - this.rightFixedLeafCount;
      } else {
        return index < this.leftFixedLeafCount || index >= this.columnsCount - this.rightFixedLeafCount;
      }
    },
    getSpan: function getSpan(row, column, rowIndex, columnIndex) {
      var rowspan = 1;
      var colspan = 1;
      var fn = this.table.spanMethod;

      if (typeof fn === 'function') {
        var result = fn({
          row: row,
          column: column,
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });

        if (Array.isArray(result)) {
          rowspan = result[0];
          colspan = result[1];
        } else if ((0, _typeof2["default"])(result) === 'object') {
          rowspan = result.rowspan;
          colspan = result.colspan;
        }
      }

      return {
        rowspan: rowspan,
        colspan: colspan
      };
    },
    getRowStyle: function getRowStyle(row, rowIndex) {
      var rowStyle = this.table.rowStyle;

      if (typeof rowStyle === 'function') {
        // eslint-disable-next-line no-useless-call
        return rowStyle.call(null, {
          row: row,
          rowIndex: rowIndex
        });
      }

      return rowStyle;
    },
    getRowClass: function getRowClass(row, rowIndex) {
      var classes = ['el-table__row'];

      if (this.table.highlightCurrentRow && row === this.store.states.currentRow) {
        classes.push('current-row');
      }

      if (this.table.detailPageHighlightCurrentRow && row === this.store.states.currentRow) {
        classes.push('detail-row');
      }

      if (this.stripe && rowIndex % 2 === 1) {
        classes.push('el-table__row--striped');
      }

      var rowClassName = this.table.rowClassName;

      if (typeof rowClassName === 'string') {
        classes.push(rowClassName);
      } else if (typeof rowClassName === 'function') {
        // eslint-disable-next-line no-useless-call
        classes.push(rowClassName.call(null, {
          row: row,
          rowIndex: rowIndex
        }));
      }

      if (this.store.states.expandRows.indexOf(row) > -1) {
        classes.push('expanded');
      }

      return classes.join(' ');
    },
    getCellStyle: function getCellStyle(rowIndex, columnIndex, row, column) {
      var cellStyle = this.table.cellStyle;

      if (typeof cellStyle === 'function') {
        // eslint-disable-next-line no-useless-call
        return cellStyle.call(null, {
          rowIndex: rowIndex,
          columnIndex: columnIndex,
          row: row,
          column: column
        });
      }

      return cellStyle;
    },
    getCellClass: function getCellClass(rowIndex, columnIndex, row, column) {
      var classes = [column.id, column.align, column.className];

      if (this.isColumnHidden(columnIndex)) {
        classes.push('is-hidden');
      } // 扩展列显示隐藏

      /** **/


      if (!column.show) {
        classes.push('is-noshow');
      }
      /** **/


      var cellClassName = this.table.cellClassName;

      if (typeof cellClassName === 'string') {
        classes.push(cellClassName);
      } else if (typeof cellClassName === 'function') {
        // eslint-disable-next-line no-useless-call
        classes.push(cellClassName.call(null, {
          rowIndex: rowIndex,
          columnIndex: columnIndex,
          row: row,
          column: column
        }));
      }

      return classes.join(' ');
    },
    handleCellMouseEnter: function handleCellMouseEnter(event, row) {
      var table = this.table;
      var cell = (0, _util.getCell)(event);

      if (cell) {
        var column = (0, _util.getColumnByCell)(table, cell);
        var hoverState = table.hoverState = {
          cell: cell,
          column: column,
          row: row
        };
        table.$emit('cell-mouse-enter', hoverState.row, hoverState.column, hoverState.cell, event);
      } // 判断是否text-overflow, 如果是就显示tooltip


      var cellChild = event.target.querySelector('.cell');

      if (!(0, _dom.hasClass)(cellChild, 'el-tooltip')) {
        return;
      } // use range width instead of scrollWidth to determine whether the text is overflowing
      // to address a potential FireFox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1074543#c3

      /** 扩展 自定义toolTip **/


      var showTooltip = (0, _dom.hasClass)(cellChild, 'showTooltip'); //不管怎么样，都要tooltip

      var customTooltipDiv = event.target.querySelector('.sk-customTooltip');
      var referenceElm = event.target.querySelector('.referenceElm');
      /** **/

      var range = document.createRange();
      range.setStart(cellChild, 0);
      range.setEnd(cellChild, cellChild.childNodes.length);
      var rangeWidth = range.getBoundingClientRect().width;
      var padding = (parseInt((0, _dom.getStyle)(cellChild, 'paddingLeft'), 10) || 0) + (parseInt((0, _dom.getStyle)(cellChild, 'paddingRight'), 10) || 0);
      /** 扩展 自定义toolTip **/

      if ((showTooltip || rangeWidth + padding > cellChild.offsetWidth || cellChild.scrollWidth > cellChild.offsetWidth) && this.$refs.tooltip) {
        var tooltip = this.$refs.tooltip; // TODO 会引起整个 Table 的重新渲染，需要优化

        this.tooltipContent = customTooltipDiv || cell.textContent || cell.innerText;
        var popperContainer = tooltip.$refs.popper.childNodes[0];
        var tipContent = this.tooltipContent.outerHTML || this.tooltipContent;

        if (tipContent === '' || tipContent === undefined || tipContent === null) {
          return;
        } // 扩展修订table中数据支持前端标签字符


        if (customTooltipDiv) {
          popperContainer.innerHTML = tipContent;
          popperContainer.childNodes[0].style.display = 'block';
        } else {
          popperContainer.textContent = tipContent;
          popperContainer.innerText = tipContent;
        }

        tooltip.referenceElm = referenceElm || cell;
        tooltip.$refs.popper && (tooltip.$refs.popper.style.display = 'none');
        tooltip.doDestroy();
        tooltip.setExpectedState(true);
        this.activateTooltip(tooltip);
      }
      /** **/

    },
    handleCellMouseLeave: function handleCellMouseLeave(event) {
      var tooltip = this.$refs.tooltip;

      if (tooltip) {
        tooltip.setExpectedState(false);
        tooltip.handleClosePopper();
      }

      var cell = (0, _util.getCell)(event);
      if (!cell) return;
      var oldHoverState = this.table.hoverState || {};
      this.table.$emit('cell-mouse-leave', oldHoverState.row, oldHoverState.column, oldHoverState.cell, event);
    },
    handleMouseEnter: function handleMouseEnter(index) {
      this.store.commit('setHoverRow', index);
    },
    handleMouseLeave: function handleMouseLeave() {
      this.store.commit('setHoverRow', null);
    },
    handleContextMenu: function handleContextMenu(event, row) {
      this.handleEvent(event, row, 'contextmenu');
      /** 扩展 右键菜单 */

      var table = this.table;
      var menus = table.menus ? table.menus : '';

      if (menus.length === 0) {
        return;
      }

      event.preventDefault(); // this.handleMenuClick(event, row, table, menus);
      // 右键菜单使用防抖

      this.debounceMenuClick(event, row, table, menus, event.currentTarget); // }, 20);

      /** */
    },

    /** 扩展 右键菜单 */
    handleMenuClick: function handleMenuClick(event, row, table, menus, currentTarget) {
      var _this3 = this;

      var oldReferenceElm = this.$el.querySelector('.el-table-menu__reference-elm');

      if (event.target === oldReferenceElm) {
        oldReferenceElm.parentNode.removeChild(oldReferenceElm);
        return;
      }

      if (oldReferenceElm) {
        oldReferenceElm.parentNode.removeChild(oldReferenceElm);
      }

      var referenceElm = document.createElement('div');
      referenceElm.className = 'el-table-menu__reference-elm';
      event.target.appendChild(referenceElm);

      if (event.target.tagName.toUpperCase() === 'TD') {
        referenceElm.style.left = (event.offsetX || event.layerX) + 'px';
        referenceElm.style.top = (event.offsetY || event.layerY) + 'px';
      } else {
        var paddingTop = event.target.offsetTop;
        referenceElm.style.left = (event.offsetX || event.layerX) + 'px';
        referenceElm.style.top = (event.offsetY || event.layerY) + paddingTop + 'px';
      }

      if (!this.menuPanel) {
        this.menuPanel = new _vue["default"](_menuPanel["default"]);
        this.menuPanel.menus = menus;
        this.menuPanel.table = table;
        this.menuPanel.referenceElm = referenceElm;
        !this.$isServer && this.menuPanel.$mount(document.createElement('div'));
      }

      this.menuPanel.row = row;
      this.menuPanel.currentTr = currentTarget;

      if (this.handleTimeout) {
        window.clearTimeout(this.handleTimeout);
      }

      this.handleTimeout = setTimeout(function () {
        _this3.menuPanel.popperJS && _this3.menuPanel.popperJS.updateReference(referenceElm);

        if (!_this3.menuPanel.showPopper) {
          _this3.menuPanel.showPopper = true;
        }

        _this3.$nextTick(function (_) {
          _this3.menuPanel.updatePopper();
        });
      }, 16);
    },

    /** */
    handleDoubleClick: function handleDoubleClick(event, row) {
      this.handleEvent(event, row, 'dblclick');
    },
    handleClick: function handleClick(event, row) {
      this.store.commit('setCurrentRow', row);
      this.handleEvent(event, row, 'click');
    },
    handleEvent: function handleEvent(event, row, name) {
      var table = this.table;
      var cell = (0, _util.getCell)(event);
      var column;

      if (cell) {
        column = (0, _util.getColumnByCell)(table, cell);

        if (column) {
          table.$emit("cell-".concat(name), row, column, cell, event);
        }
      }

      table.$emit("row-".concat(name), row, event, column);
    },
    handleExpandClick: function handleExpandClick(row, e) {
      e.stopPropagation();
      this.store.toggleRowExpansion(row);
    }
  },

  /** 扩展 右键菜单 */
  beforeDestroy: function beforeDestroy() {
    this.menuPanel && this.menuPanel.$destroy();
  }
  /** */

};
exports["default"] = _default;